import React, { FunctionComponent } from 'react';

import { useSelector } from 'react-redux';

import { i18n } from '../../../../../helpers/i18n';
import { useActions } from '../../../../../hooks';
import { selectHideParticipantsVideo, toggleHideParticipantsVideoAction } from '../../../../settings';
import { SettingsTumbler } from './settings-tumbler';

export const HideParticipantsVideoTumbler: FunctionComponent = () => {
    const { toggleHideParticipantsVideo } = useActions({
        toggleHideParticipantsVideo: toggleHideParticipantsVideoAction,
    });

    const hideParticipantsVideo = useSelector(selectHideParticipantsVideo);

    const onChange = () => toggleHideParticipantsVideo(!hideParticipantsVideo);

    return (
        <SettingsTumbler
            label={i18n('settings-v2', 'hide-participants-video-label')}
            description={i18n('settings-v2', 'hide-participants-video-description')}
            checked={hideParticipantsVideo}
            onChange={onChange}
            testId="hide-participants-video-tumbler"
        />
    );
};
